<template>
  <div>
    <div class="d-flex mb-8" style="gap: 10px">
      <div>
        <p style="font-size: 10px" class="mb-1">Start a new category</p>
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn variant="flat" color="smokeDark" v-bind="props" height="44">
              Add category
            </v-btn>
          </template>
          <v-list>
            <NewCategory ref="category" type="list" />
            <CategoryLibrary @selectTemplate="selectTemplate" />
          </v-list>
        </v-menu>
      </div>
      <div>
        <p style="font-size: 10px" class="mb-1">Status</p>
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn
              variant="flat"
              color="smokeDark"
              v-bind="props"
              height="44"
              append-icon="mdi-unfold-more-horizontal"
            >
              {{ getStatusDisplayName(filter) }}
            </v-btn>
          </template>
          <v-list density="compact">
            <v-list-item
              link
              v-for="status in statusOptions"
              :key="status.value"
              @click="filter = status.value"
            >
              <v-list-item-title>{{ status.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <div>
      <div
        style="
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
          gap: 15px;
          margin-bottom: 150px;
          max-width: 1200px;
        "
      >
        <CategoryCard
          v-for="category in filteredCategories"
          :key="category.uid"
          :category="category"
          :sources="categorySourcesMap[category.uid] || []"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CategoryCard from "@/components/category/CategoryCard.vue";
import NewCategory from "@/components/NewCategory.vue";
import CategoryLibrary from "@/components/CategoryLibrary.vue";
import { doc, updateDoc, addDoc, collection } from "firebase/firestore";
import { db } from "@/firebase";

export default {
  name: "SocialCategories",
  components: {
    CategoryCard,
    NewCategory,
    CategoryLibrary,
  },
  computed: {
    ...mapState({
      categories: (state) => state.posts.categories,
      posts: (state) => state.posts.posts,
      brand: (state) => state.workspace.brand,
      workspace: (state) => state.workspace.workspace,
      sources: (state) => state.sources.sources,
    }),
    filteredCategories() {
      let categories = this.categories || [];
      if (this.filter === "suggested") {
        categories = categories.filter((cat) => cat.status === "suggested");
      } else if (this.filter === "active") {
        categories = categories.filter((cat) => cat.status === "active");
      } else if (this.filter === "draft") {
        categories = categories.filter((cat) => cat.status === "draft");
      }
      return categories;
    },
    categorySourcesMap() {
      // Create a reactive map of category UIDs to their sources
      const map = {};
      if (this.sources && typeof this.sources === "object") {
        Object.keys(this.sources).forEach((categoryUid) => {
          map[categoryUid] = this.sources[categoryUid] || [];
        });
      }
      return map;
    },
  },
  data() {
    return {
      filter: "all",
      statusOptions: [
        { value: "all", label: "All" },
        { value: "active", label: "Active" },
        { value: "draft", label: "Draft" },
        { value: "suggested", label: "AI Suggested" },
      ],
    };
  },
  methods: {
    getStatusDisplayName(status) {
      return this.statusOptions.find((s) => s.value === status)?.label || "All";
    },
    async selectTemplate(template) {
      console.log(template);

      this.$store.commit("setLoading", { type: "categories", val: true });

      const docRef = await addDoc(
        collection(
          db,
          "workspaces",
          this.$store.state.users.userProfile.workspace,
          "categories"
        ),
        {
          active: false,
          ...template,
          schedule: {
            day_of_week: [Math.floor(Math.random() * 6) + 1],
            frequency: Math.floor(Math.random() * 4) + 1,
            type: "weeks",
            month_day: null,
            timeslot: "08:17",
            last_slot: null,
          },
          counter: {
            posts: 0,
          },
          created_at: Math.floor(Date.now() / 1000),
        }
      );

      const updateRef = doc(
        db,
        "workspaces",
        this.$store.state.users.userProfile.workspace,
        "categories",
        docRef.id
      );

      // Set the "capital" field of the city 'DC'
      await updateDoc(updateRef, {
        uid: docRef.id,
      });
      await this.$store.dispatch("fetchCategories");
      // await this.$store.dispatch("suggestCategories");
      await new Promise((resolve) => setTimeout(resolve, 3000));
      this.$store.dispatch("getCalendarDays");
      this.$store.commit("setLoading", { type: "categories", val: false });
      this.$store.commit("setNotification", {
        show: true,
        text: "Category added!",
        type: "primary",
        icon: "mdi-check",
      });
    },
  },
};
</script>

<style scoped></style>
